<template>
    <div id="confirmPaymentPage">
        <div class="d-flex flex-column justify-content-center bg-white px-0 pt-5 pb-4 pb-lg-5 mb-2">
            <merchant-details-opg/>
            <div class="px-4">
                <payment-summary-opg @totalAmount="getTotalAmount" class="mx-auto"/>
            </div>
            <!-- <cancel-request-opg class="mt-5 d-block d-lg-none" v-if="$root.$data.isAndroid"></cancel-request-opg> -->
        </div>
        <div class="d-flex flex-column bg-white p-4">
            <div class="align-items-left">
                <span class="font-sm font-weight-bold text-capitalize">Choose Payment Option</span>
                <br />
                <span class="font-xs text-gray-dk">Pay using your Home Credit funds</span>
            </div>
            <div v-if="showPaymentOption">
                <div v-for="paymentOption in paymentOptions" :key="paymentOption.id">
                <div class="d-flex flex-row py-3 py-sm-3">
                    <div class="font-sm text-capitalize radio-padding">
                        <div v-if="paymentOption.code == 'hc_loan'" class="custom-control custom-radio custom-checkbox-green">
                            <input v-if="paymentOption.isActive" :disabled="paymentOption.disabled" type="radio" :id="paymentOption.id" v-model="paymentType" @change="checkOffer(paymentOption.creditAmount)" :value="{id:paymentOption.id, code: paymentOption.code, min: paymentOption.creditAmount.min && paymentOption.creditAmount.hasOwnProperty('min') ? paymentOption.creditAmount.min : 0, max: paymentOption.creditAmount.max && paymentOption.creditAmount.hasOwnProperty('max') ? paymentOption.creditAmount.max : 0}" class="custom-control-input custom-control-input-green" />
                            <input v-else disabled type="radio" :id="paymentOption.id" class="custom-control-input custom-control-input-green" />
                            <label class="custom-control-label" :for="paymentOption.id"></label>
                        </div>
                        <div v-else class="custom-control custom-radio custom-checkbox-green">
                            <input v-if="paymentOption.isActive" :disabled="paymentOption.disabled" type="radio" :id="paymentOption.id" v-model="paymentType" @change="checkAccount(paymentType.amount)" :value="{id:paymentOption.id, code: paymentOption.code, amount: paymentOption.balance && paymentOption.balance.hasOwnProperty('amount') ? paymentOption.balance.amount : 0}" class="custom-control-input custom-control-input-green" />
                            <input v-else disabled type="radio" :id="paymentOption.id" class="custom-control-input custom-control-input-green" />
                            <label class="custom-control-label" :for="paymentOption.id"></label>
                        </div>
                    </div>
                    <div class="icon-padding">
                        <img alt="" :src="'/img/hcpay/' + paymentOption.code + '.svg'" class="hc-card-icon img-responsive" :style="paymentOption.disabled ? 'filter: grayscale(100);' : ''">
                    </div>
                    <div class="title-margin" :class="paymentOption.isActive ? '' : 'inactive-label-padding'" style="line-height: normal;" :style="paymentOption.disabled ? 'color: #00000099' : ''">
                        <span v-if="paymentOption.code == 'hc_loan'" class="font-sm font-weight-bold text-capitalize ">
                            Home Credit Installment
                            <span v-if="paymentOption.salesRoomType == 'Zero'" class="zero-tag p-1 border border-danger rounded text-danger font-xs">
                                0% interest 
                            </span>
                        </span>
                        <span v-else class="font-sm font-weight-bold text-capitalize ">
                            {{ paymentOption.name }}
                        </span>
                        <br v-if="paymentOption.isActive" />
                        <span v-if="paymentOption.isActive" class="font-xs text-gray-dk">
                            <div class="mt-2">
                                <span v-if="paymentOption.code == 'hc_loan'">
                                    <span v-if="!paymentOption.disabled">
                                    Available offer up to ₱{{ paymentOption.creditAmount.max && paymentOption.creditAmount.hasOwnProperty('max') ? toCurrency(paymentOption.creditAmount.max) : toCurrency(0)}}
                                    <br>
                                    {{  (paymentOption.hasOwnProperty('tenor') && paymentOption.tenor) && (paymentOption.tenor.hasOwnProperty('min') && paymentOption.tenor.min) ? 
                                    `Pay in ${paymentOption.tenor.min} to` : ''}}
                                    {{  (paymentOption.hasOwnProperty('tenor') && paymentOption.tenor) && (paymentOption.tenor.hasOwnProperty('max') && paymentOption.tenor.max) ? 
                                    ` ${paymentOption.tenor.max} months!` : ''}}
                                    <!-- ₱{{ paymentOption.creditAmount.min && paymentOption.creditAmount.hasOwnProperty('min') ? toCurrency(paymentOption.creditAmount.min) : toCurrency(0) }} min - ₱{{ paymentOption.creditAmount.max && paymentOption.creditAmount.hasOwnProperty('max') ? toCurrency(paymentOption.creditAmount.max) : toCurrency(0) }} max Amount -->
                                    </span>
                                    <span v-else>
                                        Reach a total purchase of ₱{{ paymentOption.creditAmount.min && paymentOption.creditAmount.hasOwnProperty('min') ? toCurrency(paymentOption.creditAmount.min) : toCurrency(0) }} to 
                                        ₱{{ paymentOption.creditAmount.max && paymentOption.creditAmount.hasOwnProperty('max') ? toCurrency(paymentOption.creditAmount.max) : toCurrency(0) }} to unlock this option!
                                    </span>
                                </span>
                                <span v-else>
                                    <span v-if="!paymentOption.disabled">
                                        Available Balance: 
                                        ₱{{  paymentOption.balance && paymentOption.balance.hasOwnProperty('amount') ?  toCurrency(paymentOption.balance.amount) : toCurrency(0)}}
                                    </span>
                                    <span v-else>
                                        Available Balance: 
                                        ₱{{  paymentOption.balance && paymentOption.balance.hasOwnProperty('amount') ?  toCurrency(paymentOption.balance.amount) : toCurrency(0)}}
                                        <br><br>
                                            Not enough funds. Make sure your total purchase is within your available balance.
                                    </span>
                                </span>
                            </div>
                        </span>
                    </div>
                    <div class="ml-3 inactive-padding" v-if="!paymentOption.isActive">
                        <span class="badge badge-primary text-dark font-xs text-capitalize inactive-badges">Inactive</span>
                    </div>
                </div>
                </div>
                <div class="d-flex flex-row warning mt-4" v-if="alertBox">
                    <div class="mr-4">
                        <img alt="" src="/img/hcpay/input-error-icon.svg" class="img-responsive errorIcon mr-1">
                    </div>
                    <div class="font-xs text-danger pt-1">
                        Your payment option does not have enough funds.
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="d-flex justify-content-center">
                    <pulse-loader :loading="loading" :color="'#C8102E'" :size="'0.5rem'"></pulse-loader>
                </div>
            </div>
            <div class="d-flex flex-column rounded align-items-center text-center py-5 px-lg-5 px-3">
                <pulse-loader :loading="loadingTwo" :color="'#C8102E'" :size="'0.5rem'"></pulse-loader>
                <div class="col-10">
                    <button 
                        type="button" 
                        id="mobileSubmitBtn"
                        @click="submit" 
                        class="btn btn-block rounded-lg font-sm font-weight-bold py-2 mt-3 mb-5" 
                        :class="!disabled ? 'btn-success' : 'btn-secondary text-gray-dk'" 
                        modalTrigger 
                        :disabled="disabled"
                    >{{paymentType.hasOwnProperty('code') && paymentType.code === 'hc_loan' ? 'Apply for Installment' : 'Confirm Payment'}}</button>
                    <cancel-request-opg id="verifyIdentityBackToStore"></cancel-request-opg>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { TRANSACTION_STATUS } from '../../mixins/transaction_status.js';
import { ERROR } from '../../mixins/error_codes.js';
import moment from 'moment';
import cancelRequest from "./cancel_request_opg2.0.vue"

const accountTypes = {
    'PHONE' : 'Phone2',
    'FCBKID' : 'Fblogo2'
}

export default {
    components: {
        cancelRequest
    },
    computed: {
        accountTypeIcon() {
            return accountTypes[this.$root.account.type];
        }
    },
    data() {
        return {
            showPaymentOption: false,
            loading: true,
            loadingTwo: false,
            alertBox: false,
            paymentOptions: [],
            paymentType: {},
            totalAmount: "0.00",
            disabled: true,
            firstNotDisabledOption: "",
        }
    },
    created() {        
        this.$root.$data.previousView = 'pin-login';

        let g4Params = {
            'userId': this.$root.$data.account.userId,
            'cuid': this.$root.$data.account.cuid,
            'ip': this.$root.transaction.ipAddress,
            'user_agent': this.$root.$data.analyticsData.userAgent,
            'phone': this.$root.$data.analyticsData.phone,
            'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
            'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
            'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
            'transaction_reference': this.$root.$data.transaction.referenceNumber,
        }       
        this.$root.triggerG4Event('checkout_page',g4Params)             
    },
    methods: {
        getPaymentOpiton() {
            let vm = this;
            axios
                .get("opg/payment_option?tid=" + this.$root.$data.tid + "&username=" + this.$root.$data.account.username + "&type=" + this.$root.$data.account.type)
                .then(response => {
                    this.paymentOptions = response.data.paymentOption.data;
                    this.showPaymentOption = true;
                    let transactionAmount = this.$root.$data.transaction.amount;
                        
                    this.paymentOptions.forEach((obj)=> {
                        if(obj.hasOwnProperty('creditAmount') && obj.creditAmount){
                            if(parseFloat(transactionAmount) >= parseFloat(obj.creditAmount.min) 
                            && parseFloat(transactionAmount) <= parseFloat(obj.creditAmount.max))
                            {
                                obj.disabled = false;
                            }
                            else{
                                obj.disabled = true;
                            }
                        }
                        else{
                            if(obj.hasOwnProperty('balance') && obj.balance){
                                if(parseFloat(transactionAmount) <= parseFloat(obj.balance.amount)){
                                    obj.disabled = false;
                                }   
                                else{
                                    obj.disabled = true;
                                }
                            }
                        } 
                    })
                    this.selectFirstActiveOption(response.data.paymentOption.data);
                    this.loading = false;
                }).catch(error => {
                    this.$root.error = error.response.data.message;
                })
        },
        selectFirstActiveOption(paymentSelected) {
            this.firstNotDisabledOption = paymentSelected.find(option => !option.disabled);
            if (this.firstNotDisabledOption) {
                if(this.firstNotDisabledOption.code == "hc_loan") {
                    this.paymentType = {
                        id: this.firstNotDisabledOption.id,
                        code: this.firstNotDisabledOption.code,
                        min: this.firstNotDisabledOption.creditAmount.min && this.firstNotDisabledOption.creditAmount.hasOwnProperty('min') ? this.firstNotDisabledOption.creditAmount.min : 0, 
                        max: this.firstNotDisabledOption.creditAmount.max && this.firstNotDisabledOption.creditAmount.hasOwnProperty('max') ? this.firstNotDisabledOption.creditAmount.max : 0
                    }
                } else {
                    this.paymentType = {
                        id: this.firstNotDisabledOption.id,
                        code: this.firstNotDisabledOption.code,
                        amount: this.firstNotDisabledOption.balance && this.firstNotDisabledOption.balance.hasOwnProperty('amount') ? this.firstNotDisabledOption.balance.amount : 0
                    }
                }
                this.disabled = false; // Enable the submit button
            }
        },
        toCurrency(value) {
            // Check if the value is NaN or empty (null, undefined, or other falsy values)
            if (!value || isNaN(value)) {
                value = 0;
            }
            
            let val = (value/1).toFixed(2).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        submit() {
            this.disabled = true;
             this.$dialog.alert('', {
                view: 'loader',
                html: true,
                customClass: 'dialog-sm',
            });
            let eventMessage = this.paymentType.code == 'hc_virtual_limit' ? 'checkout_click_hc_qwarta' : 
            this.paymentType.code == 'hc_credit_card' ? 'checkout_click_hc_cc' : 
            this.paymentType.code == 'hc_loan' ? 'checkout_click_hc_installment' : "No payment available";

            let paymentOptionLabel = null;
            switch(this.paymentType.code) {
                case "hc_credit_card":
                    paymentOptionLabel = "Home Credit Card";
                    break;
                case "hc_virtual_limit":
                    paymentOptionLabel = "Home Credit Qwarta";
                    break;
                case "hc_loan":
                    paymentOptionLabel = "Home Credit Installment";
            }
            this.$root.$data.paymentOptionLabel = paymentOptionLabel;
            let g4Params = {
                'userId': this.$root.$data.account.userId,
                'cuid': this.$root.$data.account.cuid,
                'ip': this.$root.transaction.ipAddress,
                'user_agent': this.$root.$data.analyticsData.userAgent,
                'phone': this.$root.$data.analyticsData.phone,
                'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
                'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
                'transaction_type': this.$root.$data.transaction.referenceNumber.substring(0, 2),
                'transaction_reference': this.$root.$data.transaction.referenceNumber,
                'payment_option': eventMessage,
            }       
            this.$root.triggerG4Event('checkout_click_confirm_payment',g4Params)

            axios.post(`opg/passPaymentOption?tid=${this.$root.$data.tid}&paymentOption=${this.paymentType.code}`)
            .then(response => {
                if(response.data == 1){
                    axios
                    .post("opg/confirm/payment?tid=" + this.$root.$data.tid + "&analyticsId=" + this.$root.$data.account.analyticsId)
                    .then(response => {
                            this.changeView('opg-verify-identity');
                    }).catch(error => {
                        this.cancelRequest(this.$root.$data.tid);
                        this.invalidAttempt = true;
                        this.disabled = false;
                    }).finally(() => {
                        window.dispatchEvent(new CustomEvent("loading", {
                            detail: false
                        }));
                    })
                }   
                else{
                    this.cancelRequest(this.$root.$data.tid);
                    this.invalidAttempt = true;
                    this.disabled = false;
                }
            }).catch(error => {
                this.cancelRequest(this.$root.$data.tid);
                this.invalidAttempt = true;
                this.disabled = false;
            }).finally(() =>{
                window.dispatchEvent(new CustomEvent("loading", {
                    detail: false
                }));
            })
        },
        cancelRequest(transcationId) {
            var vm = this;
            axios
                .post("hcpay/cancel_request?tid=" + transcationId)
                .then(response => {
                    this.changeView('generic-error-opg2');
                })
                .catch(error => {
                    vm.$root.error = 'TECHNICAL_PROBLEM';
                });
        },
        changeView(view) {
            this.$root.$data.view = view;
        },
        getTotalAmount(event) {
            this.totalAmount = event;
        },
        checkAccount(accountAmount) {
            this.disabled = true;
            if(this.$root.$data.transaction.amount > accountAmount) {
                this.loadingTwo = true;
                setTimeout(() => {
                    this.loadingTwo = false;
                    this.alertBox = true;
                    this.disabled = true;
                },1500);
                
            } else {
                this.loadingTwo = true;
                setTimeout(() => {
                    this.loadingTwo = false;
                    this.alertBox = false;
                    this.disabled = false;
                },1500);
            }
        },
        checkOffer(offerAmount)
        {
            this.disabled = true;
            if(this.$root.$data.transaction.amount < offerAmount.min) {
                this.loadingTwo = true;
                setTimeout(() => {
                    this.loadingTwo = false;
                    this.alertBox = true;
                    this.disabled = true;
                },1500);
            } else if(this.$root.$data.transaction.amount > offerAmount.max) {
                this.loadingTwo = true;
                setTimeout(() => {
                    this.loadingTwo = false;
                    this.alertBox = true;
                    this.disabled = true;
                },1500);
            } else {
                this.loadingTwo = true;
                setTimeout(() => {
                    this.loadingTwo = false;
                    this.alertBox = false;
                    this.disabled = false;
                },1500);
            }
        }
    },
    mounted() {
        this.getPaymentOpiton()      
    },
    watch: {
        paymentType: {
            handler: function() {
            //    console.log(this.paymentType)
            }
        },
    },
}
</script>
<style scoped>
    input[type="radio"]:checked {
        background-color: #49B672;
    }
    .accountTypeIcon {
        height: auto;
        width: 1.5rem;
    }
    .verifyIdentityStepIcon {
        height: auto;
        width: 2.5rem;
    }
    .radio-padding {
        padding-top: 8px;
    }
    .icon-padding {
        padding: 7px;
        margin-left: 1rem !important;
    }
    .title-margin {
        margin-left: 1rem !important;
    }
    .zero-tag {
        margin-left: 1.5rem !important;
    }
    .hc-card-icon {
        width: 32px;
    }
    .warning {
        width: 100%;
        height: 40px;
        padding: 5px 5px 5px 15px;
        /* UI Properties */
        background: #FFF7F7 0% 0% no-repeat padding-box;
        border-radius: 4px;
        opacity: 1;
    }
    .errorIcon {
        width: 24px;
    }
    .custom-control-input-green:focus~.custom-control-label::before {
        border-color: #28a745 !important;
        box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;        
    }

    .custom-control-input-green:checked~.custom-control-label::before {
        border-color: #28a745 !important;
        background-color: #28a745 !important;
    }

    .custom-control-input-green:focus:not(:checked)~.custom-control-label::before {
        border-color: #5bd778 !important;
    }

    .custom-control-input-green:not(:disabled):active~.custom-control-label::before {
        background-color: #d6f5dd !important;
        border-color: #d6f5dd !important;
    }

    .active-badges{
        background-color: #49B672;
        font-size: 10px;
        padding: 4px;
    }
    .inactive-badges{
        background-color: #0000001A;
        font-size: 10px;
        padding: 4px;
    }

    .inactive-label-padding{
        padding-top: 13px;
    }

    .inactive-padding{
        padding-top: 10px;
    }
    
    @media only screen and (max-width: 768px) {
        .icon-padding {
            padding-top: 7px;
            margin-left: 0rem !important;
        }
        .title-margin {
            margin-left: 0.25rem !important;
        }
        .zero-tag {
            margin-left: 0.5rem !important;
        }
    }
</style>
 